import { createDataSelectors } from "@app/modules/app.reducers";
import { ScriptChangelog } from "@ea/shared_types/types";

export const scriptChangelogDataSelectors =
  createDataSelectors<ScriptChangelog>()("scriptChangelog");
